// import React, { useEffect, useState } from "react";
// import { signOut, onAuthStateChanged } from "firebase/auth";
// import { auth, db } from "../firebase";
// import { useNavigate } from "react-router-dom";
// import { setAnalyticsCollectionEnabled } from "firebase/analytics";
// import { uid } from "uid";
// import { set, ref, onValue, remove, update } from "firebase/database";

// export default function Homepage() {
//   const [todo, setTodo] = useState("");
//   const [todos, setTodos] = useState([]);
//   const [isEdit, setIsEdit] = useState(false);
//   const [tempUidd, setTempUidd] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     auth.onAuthStateChanged((user) => {
//       if (user) {
//         onValue(ref(db, `/${auth.currentUser.uid}`), (snapshot) => {
//           setTodos([]);
//           const data = snapshot.val();
//           if (data !== null) {
//             Object.values(data).map((todo) => {
//               setTodos((oldArray) => [...oldArray, todo]);
//             });
//           }
//         });
//       } else if (!user) {
//         navigate("/");
//       }
//     });
//   }, []);

//   const handleSignOut = () => {
//     signOut(auth)
//       .then(() => {
//         navigate("/");
//       })
//       .catch((err) => {
//         alert(err.message);
//       });
//   };

//   const writeToDatabase = () => {
//     const uidd = uid();
//     set(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
//       todo: todo,
//       uidd: uidd,
//     });
//     setTodo("");
//   };

//   const handleUpdate = (todo) => {
//     setIsEdit(true);
//     setTodo(todo.todo);
//     setTempUidd(todo.uidd);
//   };

//   const handleEditConfirm = () => {
//     update(ref(db, `/${auth.currentUser.uid}/${tempUidd}`), {
//       todo: todo,
//       tempUidd: tempUidd,
//     });
//     setTodo("");
//     setIsEdit(false);
//   };

//   const handleDelete = (uid) => {
//     remove(ref(db, `${auth.currentUser.uid}/${uid}`));
//   };

//   return (
//     <div>
//       <input
//         type="text"
//         placeholder="Add Todo"
//         value={todo}
//         onChange={(e) => setTodo(e.target.value)}
//       />
//       {todos.map((todo) => (
//         <div>
//           <h1>{todo.todo}</h1>
//           <button onClick={() => handleUpdate(todo.uidd)}>Update</button>
//           <button onClick={() => handleDelete(todo.uidd)}>Delete</button>
//         </div>
//       ))}
//       {isEdit ? (
//         <div>
//           <button onClick={handleEditConfirm}>Confirm</button>
//         </div>
//       ) : (
//         <div>
//           <button onClick={writeToDatabase}>add</button>
//         </div>
//       )}

//       <button onClick={handleSignOut}>Sign Out</button>
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { signOut, onAuthStateChanged } from "firebase/auth";
// import { auth, db } from "../firebase";
// import { useNavigate } from "react-router-dom";
// import { setAnalyticsCollectionEnabled } from "firebase/analytics";
// import { uid } from "uid";
// import { set, ref, onValue, remove, update } from "firebase/database";
// import "./homepage.css";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LogoutIcon from "@mui/icons-material/Logout";
// import CheckIcon from "@mui/icons-material/Check";

// export default function Homepage() {
//   const [todo, setTodo] = useState("");
//   const [todos, setTodos] = useState([]);
//   const [isEdit, setIsEdit] = useState(false);
//   const [tempUidd, setTempUidd] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     auth.onAuthStateChanged((user) => {
//       if (user) {
//         onValue(ref(db, `/${auth.currentUser.uid}`), (snapshot) => {
//           setTodos([]);
//           const data = snapshot.val();
//           if (data !== null) {
//             const todosArray = Object.values(data);
//             setTodos(todosArray);
//           }
//         });
//       } else if (!user) {
//         navigate("/");
//       }
//     });
//   }, [auth, navigate]);

//   const handleSignOut = () => {
//     signOut(auth)
//       .then(() => {
//         navigate("/");
//       })
//       .catch((err) => {
//         alert(err.message);
//       });
//   };

//   const writeToDatabase = () => {
//     const uidd = uid();
//     set(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
//       todo: todo,
//       uidd: uidd,
//     });
//     setTodo("");
//   };

//   const handleUpdate = (todo) => {
//     setIsEdit(true);
//     setTodo(todo.todo);
//     setTempUidd(todo.uidd);
//   };

//   const handleEditConfirm = () => {
//     update(ref(db, `/${auth.currentUser.uid}/${tempUidd}`), {
//       todo: todo,
//     });
//     setTodo("");
//     setIsEdit(false);
//   };

//   const handleDelete = (uid) => {
//     remove(ref(db, `${auth.currentUser.uid}/${uid}`));
//   };

//   return (
//     <div className="homepage">
//       <input
//         className="add-edit-input"
//         type="text"
//         placeholder="Add Todo"
//         value={todo}
//         onChange={(e) => setTodo(e.target.value)}
//       />

//       {todos.map((todo) => (
//         <div className="todo" key={todo.uidd}>
//           <h1>{todo.todo}</h1>
//           <EditIcon
//             fontSize="large"
//             onClick={() => handleUpdate(todo)}
//             className="edit-button"
//           />
//           <DeleteIcon
//             fontSize="large"
//             onClick={() => handleDelete(todo.uidd)}
//             className="delete-button"
//           />
//         </div>
//       ))}
//       {isEdit ? (
//         <div>
//           <CheckIcon onClick={handleEditConfirm} className="add-confirm-icon" />
//         </div>
//       ) : (
//         <div>
//           <AddIcon onClick={writeToDatabase} className="add-confirm-icon" />
//         </div>
//       )}
//       <LogoutIcon onClick={handleSignOut} className="logout-icon" />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import {
  set,
  ref,
  onValue,
  remove,
  update,
  serverTimestamp,
} from "firebase/database";
import { uid } from "uid";
import "./homepage.css";
// import "./homepage2.css";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LogoutIcon from "@mui/icons-material/Logout";
import CheckIcon from "@mui/icons-material/Check";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function Homepage() {
  const [todo, setTodo] = useState("");
  const [todos, setTodos] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [tempUidd, setTempUidd] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        onValue(ref(db, `/${auth.currentUser.uid}`), (snapshot) => {
          setTodos([]);
          const data = snapshot.val();
          if (data !== null) {
            const todosArray = Object.entries(data).map(([uidd, note]) => ({
              uidd,
              ...note,
            }));
            const sortedTodos = todosArray.sort(
              (a, b) => a.timestamp - b.timestamp
            ); // Sort by timestamp
            setTodos(sortedTodos);
          }
        });
      } else if (!user) {
        navigate("/");
      }
    });
  }, [auth, navigate]);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  // const writeToDatabase = () => {
  //   const uidd = uid();
  //   set(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
  //     todo: todo,
  //     uidd: uidd,
  //     timestamp: serverTimestamp(), // Add timestamp
  //   });
  //   setTodo("");
  // };

  const writeToDatabase = () => {
    const uidd = uid();
    set(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
      todo: todo,
      uidd: uidd,
      timestamp: serverTimestamp(),
      isLineThrough: false, // Initialize isLineThrough property
    });
    setTodo("");
  };

  const handleUpdate = (todo) => {
    setIsEdit(true);
    setTodo(todo.todo);
    setTempUidd(todo.uidd);
  };

  const handleEditConfirm = () => {
    update(ref(db, `/${auth.currentUser.uid}/${tempUidd}`), {
      todo: todo,
    });
    setTodo("");
    setIsEdit(false);
  };

  const handleDelete = (uid) => {
    remove(ref(db, `${auth.currentUser.uid}/${uid}`));
  };

  // const handleToggleLineThrough = (uidd) => {
  //   // Find the todo by uidd and toggle the line-through class
  //   const updatedTodos = todos.map((todo) => {
  //     if (todo.uidd === uidd) {
  //       return { ...todo, isLineThrough: !todo.isLineThrough };
  //     }
  //     return todo;
  //   });
  //   setTodos(updatedTodos);
  // };

  const handleToggleLineThrough = (uidd) => {
    const updatedTodos = todos.map((todo) => {
      if (todo.uidd === uidd) {
        const newIsLineThrough = !todo.isLineThrough;
        update(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
          isLineThrough: newIsLineThrough,
        });
        return { ...todo, isLineThrough: newIsLineThrough };
      }
      return todo;
    });
    setTodos(updatedTodos);
  };

  return (
    <div className="homepage">
      <h1 className="headline">
        ਕਬੀਰ ਕਾਲਿ ਕਰੰਤਾ ਅਬਹਿ ਕਰੁ ਅਬ ਕਰਤਾ ਸੁਇ ਤਾਲ ॥ <br />
        ਪਾਛੈ ਕਛੂ ਨ ਹੋਇਗਾ ਜਉ ਸਿਰ ਪਰਿ ਆਵੈ ਕਾਲੁ ॥੧੩੮॥
      </h1>
      {/* <form
        onSubmit={(e) => {
          e.preventDefault();
          writeToDatabase();
        }}
      >
        <input
          className="add-edit-input"
          type="text"
          placeholder="Add Todo"
          value={todo}
          onChange={(e) => setTodo(e.target.value)}
        />
      </form> */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          writeToDatabase();
        }}
      >
        <input
          className="input-container"
          type="text"
          placeholder="Enter a new to do"
          value={todo}
          onChange={(e) => setTodo(e.target.value)}
        />
        {/* <div className="btn_container">
          <button>Add</button>
        </div> */}
        {isEdit ? (
          <div>
            <CheckIcon
              fontSize="large"
              onClick={handleEditConfirm}
              className="btn_container"
            />
          </div>
        ) : (
          <div>
            <AddIcon
              fontSize="large"
              onClick={writeToDatabase}
              className="btn_container"
            />
          </div>
        )}
      </form>

      {/* {todos.map((todo) => (
        <div className="todo" key={todo.uidd}>
          <h1>{todo.todo}</h1>
          <EditIcon
            fontSize="large"
            onClick={() => handleUpdate(todo)}
            className="edit-button"
          />
          <DeleteIcon
            fontSize="large"
            onClick={() => handleDelete(todo.uidd)}
            className="delete-button"
          />
        </div>
      ))} */}

      {todos.map((todo) => (
        <div
          className={`todo ${todo.isLineThrough ? "line-through" : ""}`}
          key={todo.uidd}
        >
          <h1>{todo.todo}</h1>
          <div>
            <CheckCircleOutlineIcon
              fontSize="medium"
              onClick={() => handleToggleLineThrough(todo.uidd)}
              className="done-button"
            />
          </div>
          <EditIcon
            fontSize="medium"
            onClick={() => handleUpdate(todo)}
            className="edit-button"
          />
          <DeleteIcon
            fontSize="medium"
            onClick={() => handleDelete(todo.uidd)}
            className="delete-button"
          />
          {/* <button onClick={() => handleToggleLineThrough(todo.uidd)}>
            Toggle Line-Through
          </button> */}
        </div>
      ))}

      {/* {isEdit ? (
        <div>
          <CheckIcon onClick={handleEditConfirm} className="add-confirm-icon" />
        </div>
      ) : (
        <div>
          <AddIcon onClick={writeToDatabase} className="add-confirm-icon" />
        </div>
      )} */}

      <LogoutIcon onClick={handleSignOut} className="logout-icon" />
    </div>
  );
}
